import { render, staticRenderFns } from "./TransportationProfile.vue?vue&type=template&id=4db123f0&scoped=true&"
import script from "./TransportationProfile.vue?vue&type=script&lang=js&"
export * from "./TransportationProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db123f0",
  null
  
)

export default component.exports